module.exports = __webpack_public_path__ + "img/logo512.f6aa7423.png";